export const fcmforWebConstant = () => {
  return "FCMforWeb";
};
export const ContactUsOptions = [
  { label: "App not responding", value: "App not responding" },
  {
    label: "Items not showing in the list",
    value: "Items not showing in the list",
  },
  { label: "Store is not in the list", value: "Store is not in the list" },
  {
    label: "Price in comparison is different than in the store",
    value: "Price in comparison is different than in the store",
  },
  {
    label: "Not able to share shopping list within the users",
    value: "Not able to share shopping list within the users",
  },
  { label: "Not able to place order", value: "Not able to place order" },
  { label: "Others", value: "Others" },
];

export const AdminEmail = "writetomav@mavencery.com";

export const isValidEmail = (email) => {
  let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const playStoreUrl =
  "https://play.google.com/store/apps/details?id=com.mavencery.productbox";
export const appStoreUrl =
  "https://apps.apple.com/pk/app/mavencery-app/id6446471935";

export const mavenceryPrivacyPolicy = "https://mavencery.com/privacy-policy";
export const storesThemes = [
  {
    logo: "https://firebasestorage.googleapis.com/v0/b/mavencery-2b9a6.appspot.com/o/stores%2Flogos%2FGul's%20Store.png?alt=media&token=06e31317-6df2-4db7-b037-63a9bbcdeefc",
    id: 7,
    name: "Nisa Local",
    theme: {
      color: "#030F31",
      ligtherColor: "#000000",
      backgroundColor: "#030F31",
    },
    cover:
      "https://firebasestorage.googleapis.com/v0/b/mavencery-2b9a6.appspot.com/o/stores%2Flogos%2FGul's%20Store.png?alt=media&token=06e31317-6df2-4db7-b037-63a9bbcdeefc",

    isWhiteLabel: true,
    whiteLogo:
      "https://firebasestorage.googleapis.com/v0/b/mavencery-2b9a6.appspot.com/o/stores%2Flogos%2FGul's%20Store.png?alt=media&token=06e31317-6df2-4db7-b037-63a9bbcdeefc",
  },
  {
    id: 14, //production store al-halal id is 14
    theme: {
      color: "#FF6452",
      backgroundColor: "#FF6452",
    },
    isWhiteLabel: true,
    name: "Al Halal Meats",
    cover:
      "https://firebasestorage.googleapis.com/v0/b/mavencery-2b9a6.appspot.com/o/stores%2Flogos%2FAlHalalMeatsListCover.png?alt=media&token=0338fe8d-6f75-476f-b005-0d4069eb0375",
    logo: "https://firebasestorage.googleapis.com/v0/b/mavencery-2b9a6.appspot.com/o/stores%2Flogos%2FALHALALMEATSLOGO.png?alt=media&token=61eedda2-04b1-47dd-a43d-f4cbd0ac0f3d",
    whiteLogo:
      "https://firebasestorage.googleapis.com/v0/b/mavencery-2b9a6.appspot.com/o/stores%2Flogos%2FalahalalMeatsLogo.png?alt=media&token=d4962c91-7c3e-4a87-af76-47ce6e0206ac",
  },
];

export const DATE_FORMAT = "DD/MM/YYYY";

export const Texts = {
  nisaLocalSignupAndJoinText: "Join Nisa Local Today and Save",
  alHalalSignupAndJoinText: "Join Al Halal Meats Today and Save",
  mavencerySignupAndJoinText: "Join Mavencery Today and Save",
  mavencerySignupDescriptionText:
    "Sign up to create and manage shared grocery lists, compare prices in real time across multiple stores, and choose the most convenient way to shop—whether it's in-store, curbside pick-up, or delivery. Track your spending, control your budget, and shop smarter with personalized insights and customized lists.",
  alHalalSignupDescriptionText:
    "Enjoy 10% off every order, free local delivery for orders over £30 (LU3), and shop with confidence from Luton’s cleanest butchery. We’re HMC Certified and have a 5-star hygiene rating. Create your account and start enjoying exclusive offers and fresh, halal meats delivered to your door!",
  nisaLocalSignupDescriptionText:
    "Enjoy 10% off every order, free local delivery for orders over £30 (LU3), and shop with confidence from Luton’s cleanest butchery. We’re HMC Certified and have a 5-star hygiene rating. Create your account and start enjoying exclusive offers and fresh, Nisa Local  delivered to your door!",
  mavenceryLoginDescriptionText:
    "Pick up right where you left off! Access your shared grocery lists, compare prices across stores, and manage your shopping with ease. Track your spending and enjoy a seamless shopping experience, whether you’re shopping in-store, curbside, or scheduling a delivery. Log in to make the most of Mavencery's smart shopping features!",

  alHalalLoginDescriptionText:
    "Access the finest halal meats, responsibly sourced and delivered fresh to your doorstep with Al Halal Meats. Manage orders easily, explore personalized deals, and enjoy a seamless shopping experience. Whether for daily meals or special occasions, we guarantee quality and convenience every time. Pick up right where you left off and shop with confidence.",
  nisaLocalLoginDescriptionText:
    "Access the finest meat in Luton, responsibly sourced and delivered fresh to your doorstep with Nisa Local Store. Manage orders easily, explore personalized deals, and enjoy a seamless shopping experience. Whether for daily meals or special occasions, we guarantee quality and convenience every time. Pick up right where you left off and shop with confidence.",
  alreadyAccountText: "Already have an account?",
  createAccountText: "Don't have an account?",
  loginText: "Log In to Your Account",
};

export const MAVENCERY_STORES_NAMES = {
  AlHalalMeats: "Al Halal Meats",
  NisaLocal: "Nisa Local",
};

export const OrderDeliveryPickupInfo = (type) => {
  return type === "Delivery"
    ? "Your card will get hold once the order is placed, but will deduct at the time of delivery. Note that delivery will be from 6 pm same day. Do you really want to continue?"
    : "Your card will get hold once the order is placed. Amount will get deducted in case you won't pick up your order. Do you really want to continue?";
};
